import { Button, Card, Grid, Text } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router';
import useFacebookSDK from '../../helpers/useFacebookSDK';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';

const FacebookConnectButton = ({ setFacebookAccount }) => {
  // Be careful to not include permissions that we do not need because
  // our app will not be accepted when we submit it for review
  const apiPermissions = [
    'catalog_management',
    'business_management',
    'ads_management',
    'pages_show_list',
    'ads_read',
    'whatsapp_business_management',
    'whatsapp_business_messaging',
  ];
  const fetch = useFetch();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const { sdkLoaded, sdkError } = useFacebookSDK();
  const { accountId, domainId } = useParams();

  const handleLogin = () => {
    if (!sdkLoaded || !window.FB) {
      setError('Facebook SDK not loaded. Please refresh the page and try again.');
      return;
    }

    setError(null);
    setLoading(true);

    window.FB.login(
      (response) => {
        if (!response.authResponse) {
          setLoading(false);
          setError('Facebook login was cancelled or failed. Please try again.');
          return;
        }

        (async () => {
          try {
            const { user } = await fetch(
              `/api/admin/accounts/${accountId}/domains/${domainId}/facebook/login`,
              {
                method: 'POST',
                body: JSON.stringify({
                  shortLivedAccessToken: response.authResponse.accessToken,
                }),
              }
            );

            setFacebookAccount(user);
          } catch (error) {
            setError(error.message || 'Failed to connect Facebook. Please try again.');
          } finally {
            setLoading(false);
          }
        })();
      },
      { scope: apiPermissions.join(',') }
    );
  };

  return (
    <Card withBorder>
      <Grid>
        <Grid.Col span={4}>
          <Text fw={500}>Connection</Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <Button
            variant="filled"
            onClick={handleLogin}
            loading={loading}
            disabled={!sdkLoaded}
          >
            Connect Facebook to Releva
          </Button>

          <ErrorMessage message={error || sdkError} />
        </Grid.Col>
      </Grid>
    </Card>
  );
};

export default FacebookConnectButton;
